import { render, staticRenderFns } from "./AuditLogForUser.vue?vue&type=template&id=70672303&scoped=true&"
import script from "./AuditLogForUser.vue?vue&type=script&lang=js&"
export * from "./AuditLogForUser.vue?vue&type=script&lang=js&"
import style1 from "./AuditLogForUser.vue?vue&type=style&index=1&id=70672303&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70672303",
  null
  
)

export default component.exports